import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=5bc2a6de"
import script from "./tab-bar.js?vue&type=script&lang=js&external"
export * from "./tab-bar.js?vue&type=script&lang=js&external"
import style0 from "./tab-bar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports